import { all, fork, put, takeEvery, call, takeLatest } from 'redux-saga/effects';
import { CommodityActionTypes } from './constants';

import { commodity, createCommodity, updateCommodity, deleteCommodity, uploadCommodity } from './api';
import { toast } from 'react-toastify';
/**
 * Login the user
 * @param {*} payload - username and password
 */

function* commodityDataGetFunction(data) {
    try {
        yield put({
            type: CommodityActionTypes.COMMODITY_DATA_LOADING,
            payload: {},
        });
        const response = yield call(commodity, data);
        if (response.data.status) {
            yield put({
                type: CommodityActionTypes.COMMODITY_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: CommodityActionTypes.COMMODITY_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: CommodityActionTypes.COMMODITY_DATA_ERROR,
            payload: error,
        });
    }
}

function* commodityDataCreateFunction(data) {
    try {
        yield put({
            type: CommodityActionTypes.CREATE_COMMODITY_DATA_LOADING,
            payload: {},
        });
        const response = yield call(createCommodity, data);
        if (response.data.status) {
            yield put({
                type: CommodityActionTypes.CREATE_COMMODITY_DATA_SUCCESS,
                payload: { ...response.data },
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: CommodityActionTypes.CREATE_COMMODITY_DATA_ERROR,
                payload: { ...response.data },
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        toast.error(error || 'Error creating commodity');
        yield put({
            type: CommodityActionTypes.CREATE_COMMODITY_DATA_ERROR,
            payload: error,
        });
    }
}

function* commodityDataUpdateFunction(payload) {
    try {
        yield put({
            type: CommodityActionTypes.UPDATE_COMMODITY_DATA_LOADING,
        });

        const response = yield call(updateCommodity, payload);

        if (response && response.data) {
            yield put({
                type: CommodityActionTypes.UPDATE_COMMODITY_DATA_SUCCESS,
                payload: response.data,
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: CommodityActionTypes.UPDATE_COMMODITY_DATA_ERROR,
                payload: response.data,
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        yield put({
            type: CommodityActionTypes.UPDATE_COMMODITY_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}

function* commodityDataDeleteFunction(payload) {
    try {
        yield put({
            type: CommodityActionTypes.DELETE_COMMODITY_DATA_LOADING,
        });

        const response = yield call(deleteCommodity, payload);

        if (response && response.data) {
            yield put({
                type: CommodityActionTypes.DELETE_COMMODITY_DATA_SUCCESS,
                payload: response.data,
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: CommodityActionTypes.DELETE_COMMODITY_DATA_ERROR,
                payload: response.data,
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        toast.success(error || error.message);
        yield put({
            type: CommodityActionTypes.DELETE_COMMODITY_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}

function* commodityDataUploadFunction(data) {
    try {
        yield put({
            type: CommodityActionTypes.UPLOAD_COMMODITY_DATA_LOADING,
            payload: {},
        });
        const response = yield call(uploadCommodity, data);
        if (response.data.status) {
            yield put({
                type: CommodityActionTypes.UPLOAD_COMMODITY_DATA_SUCCESS,
                payload: { ...response.data },
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: CommodityActionTypes.UPLOAD_COMMODITY_DATA_ERROR,
                payload: { ...response.data },
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        toast.success(error || error.message);
        yield put({
            type: CommodityActionTypes.UPLOAD_COMMODITY_DATA_ERROR,
            payload: error,
        });
    }
}

export function* watchCommodityDataGet() {
    yield takeLatest(CommodityActionTypes.COMMODITY_DATA_FIRST, commodityDataGetFunction);
}
export function* watchCommodityDataCreate() {
    yield takeEvery(CommodityActionTypes.CREATE_COMMODITY_DATA_FIRST, commodityDataCreateFunction);
    yield takeEvery(CommodityActionTypes.UPLOAD_COMMODITY_DATA_FIRST, commodityDataUploadFunction);
}
export function* watchCommodityDataUpdate() {
    yield takeLatest(CommodityActionTypes.UPDATE_COMMODITY_DATA_FIRST, commodityDataUpdateFunction);
}
export function* watchCommodityDataDelete() {
    yield takeEvery(CommodityActionTypes.DELETE_COMMODITY_DATA_FIRST, commodityDataDeleteFunction);
}
function* commoditySaga() {
    yield all([
        fork(watchCommodityDataGet),
        fork(watchCommodityDataCreate),
        fork(watchCommodityDataUpdate),
        fork(watchCommodityDataDelete),
    ]);
}
export default commoditySaga;
